import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { teethCollection } from "./TeethSvgs";
import { companyType } from "../../../../../colors-config";
import { iprLowerIndexes, iprUpperIndexes } from "Components/IPR/utils";

const ToothSvg = ({ id }) => {
  const ToothComponent = teethCollection[+id];
  return ToothComponent ? <ToothComponent /> : <div>No SVG for ID {id}</div>;
};

const Tooth = ({ tooth, chartValue }) => {
  const attachmentDetails = useSelector(
    (state) => state.model.attachtmentDetails
  );
  const upperModelIndex = useSelector((state) => state.model.upperModelIndex);
  const lowerModelIndex = useSelector((state) => state.model.lowerModelIndex);
  const [activeTooths, setActiveTooths] = useState([]);
  const [pressurePointData,setPressurePointData] = useState([])

  const toothNameSwitcher = (t, value) => {
    if (value === "fdi") {
      return t.fdiName;
    } else if (value === "universal") {
      return t.universalName;
    } else {
      return t.palmerName;
    }
  };
  useEffect(() => {
    const upperValues = [];
    const lowerValues = [];
    const tableData = [];
    const pressurePointArray = []

    attachmentDetails &&
      [...attachmentDetails]?.forEach((el) => {
        if (el.jawType === "upper" && el.aligner_count === upperModelIndex) {
          upperValues.push(el);
        }
        if (el.jawType === "lower" && el.aligner_count === lowerModelIndex) {
          lowerValues.push(el);
        }
      });

    const selectedAlignerDataUpper = upperValues?.filter(
      (el) => el.aligner_count === upperModelIndex
    ) || [upperValues[0]];
    // console.log("selectedAlignerDataUpper", selectedAlignerDataUpper)
    const selectedAlignerDataLower = lowerValues?.filter(
      (el) => el.aligner_count === lowerModelIndex
    ) || [lowerValues[0]];

    selectedAlignerDataUpper[0]?.alignerValues.forEach((el, index) => {
      if (el?.value) {
        tableData.push(el.teeth);
      }
      if (el.pressureLine === "yes") {
        pressurePointArray.push(el.teeth)
      }
    });
    selectedAlignerDataLower[0]?.alignerValues.forEach((el, index) => {
      if (el?.value) {
        tableData.push(el.teeth);
      }
      if (el.pressureLine === "yes") {
        pressurePointArray.push(el.teeth)
      }
    });
    // console.log("pressurePointArraypressurePointArray", pressurePointArray)
    setActiveTooths(tableData);
    setPressurePointData(pressurePointArray)
  }, [attachmentDetails, upperModelIndex, lowerModelIndex]);

  return (
    <div
    className={`teeth-structure 
      ${activeTooths.includes(tooth.id) ? (companyType === 5 ? "active-teeth-sa" : companyType === 6 ? "active-teeth-ias" : "active-teeth") : ""} 
      ${pressurePointData.includes(tooth.id) ? (companyType === 5 ? "stroke-teeth-sa" : "stroke-teeth") : ""}`}    
    >
      {<ToothSvg id={tooth.showName} />}
      <span>{toothNameSwitcher(tooth, chartValue)}</span>
      {/* </Tooltip> */}
    </div>
  );
};

export default Tooth;
